import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import type {TipsItem} from '@/services/content/tipsContent.types';
import {selectInitialGuideItemType, selectIsDeepLinkEntry} from '@/state/selectors/app';
import {setInitialGuideItemType} from '@/state/slices/appSlice';
import {dispatch} from '@/state/store';

/**
 * A group deep-linked from another module (e.g. Experience Coach) opens directly as the root view -
 * no Tips list beneath it - so there is no menu flash and its Back returns to the host.
 *
 * The lookup is frozen on the first render: the deep-link payload arrives with init and does not
 * change afterwards. The marker in the store is then cleared so a later remount does not
 * re-consume it. The standalone flow clears the marker from its own hook, so we only touch it in
 * the deep-link branch.
 */
const useDeepLinkCard = (cards: TipsItem[]): TipsItem | undefined => {
    const isDeepLinkEntry = useSelector(selectIsDeepLinkEntry);
    const initialGuideItemType = useSelector(selectInitialGuideItemType);

    const [deepLinkCard] = useState(() =>
        isDeepLinkEntry && initialGuideItemType
            ? (cards.find((c) => c.guideItemType === initialGuideItemType) as TipsItem | undefined)
            : undefined
    );

    useEffect(() => {
        if (deepLinkCard) dispatch(setInitialGuideItemType());
    }, [deepLinkCard]);

    return deepLinkCard;
};

export default useDeepLinkCard;
